<hyperkit-dialog class="hyperkit-component" headerText="Talk With Us">
  <div class="body">
    <div class="test">
      <div class="column column-one">
        <div class="content-wrapper">
          <img
            style="margin-right: 5px"
            width="24"
            height="24"
            src="/assets/img/icons/cyborg-premium.png"
          />
          <div>
            <hyperkit-typography
              variant="body"
              size="md"
              align="left"
              color="body"
            >
              Connect with us to see what we can do for you as you try out
              HUNTER Community.</hyperkit-typography
            >
            <div class="point">
              <i class="k-icon k-font-icon k-i-file-ascx"></i>
              <div class="content">
                <hyperkit-typography
                  variant="emphasized"
                  size="sm"
                  align="left"
                  color="primary"
                  >Trial Hunt Management Module Access</hyperkit-typography
                >
                <hyperkit-typography
                  variant="body"
                  size="md"
                  align="left"
                  color="body"
                >
                  Utilize features to customize queries, generate detailed
                  post-hunt reports, document hunt notes efficiently, and track
                  essential metrics/KPIs.</hyperkit-typography
                >
              </div>
            </div>
            <div class="point">
              <i class="k-icon k-font-icon k-i-html"></i>
              <div class="content">
                <hyperkit-typography
                  variant="emphasized"
                  size="sm"
                  align="left"
                  color="primary"
                  >Customized Guided Hunt Plan</hyperkit-typography
                >
                <hyperkit-typography
                  variant="body"
                  size="md"
                  align="left"
                  color="body"
                  >Receive a curated list of Hunt Packages targeting prominent
                  Malware/Ransomware Families, TTPs, and relevant threat actors
                  to your organization.</hyperkit-typography
                >
              </div>
            </div>
            <div class="point">
              <i class="k-icon k-font-icon k-i-chart-line-stacked"></i>
              <div class="content">
                <hyperkit-typography
                  variant="emphasized"
                  size="sm"
                  align="left"
                  color="primary"
                  >Tailored Hunt Collection
                </hyperkit-typography>
                <hyperkit-typography
                  variant="body"
                  size="md"
                  align="left"
                  color="body"
                  >Unlock exclusive access to premium hunt content and
                  specialized hunt package collections tailored to your
                  needs.</hyperkit-typography
                >
              </div>
            </div>
            <hyperkit-button
              size="small"
              color="tertiary"
              text=" Talk to an Intel 471 Expert"
              (click)="talkToCyborg()"
            ></hyperkit-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</hyperkit-dialog>
